import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

/**
 * Count the invocations associated with a dataset that have reached a terminal
 * status (Completed, Cancelled, Failed, or Deadly).
 */
export function useTerminalInvocationCount(datasetId: string | undefined) {
  const { actionService } = useDomainServices();
  const { currentOrganization } = useAuth();

  return useQuery({
    queryKey: [
      "terminalInvocationCount",
      datasetId,
      currentOrganization?.org_id,
    ],
    queryFn: async ({ signal }) => {
      if (currentOrganization === null) {
        throw new Error("Requires login");
      }

      if (datasetId === undefined) {
        throw new Error("Requires datasetId");
      }

      return actionService.countTerminalInvocationsForDataset(
        currentOrganization.org_id,
        datasetId,
        { abortSignal: signal },
      );
    },
    enabled: currentOrganization !== null && datasetId !== undefined,
  });
}
